import React from 'react'
import styles from './styles/SingleNewsCard.module.scss'
import { ReactComponent as NewsArrow } from '../../../../assets/images/NewsArrow.svg';

function SingleNewsCard({ key, image, title, Date, excerpt, slug, colors }) {

  return (
    <div
      className={styles.postCard}
      style={{ '--card-border-color': colors.border }}
    >
      <div className={styles.imageContainer}>
        <img src={image} alt="Post" />
        <a href={`/news/${slug}`}>
          <span className={styles.expandIcon}><NewsArrow /></span>
        </a>
      </div>
      <div className={styles.content}>
        <span className={styles.date}>{Date}</span>
        <h3>{title}</h3>
        <p>{excerpt}</p>
        <div className={styles.actions}>
          <a href={`/news/${slug}`} style={{color: colors.secondary}}>Read more</a>↗
          {/* <button className={styles.aiBtn}>★ Ai</button> */}
        </div>
      </div>
    </div>
  )
}

export default SingleNewsCard